var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVentureverselightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 157,
    viewBox: "0 0 179 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1732_19098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2962 102.739L127.524 21.2845C128.944 20.0953 130.926 21.8322 129.934 23.3956L90.0095 86.2969C89.4209 87.2241 89.9054 88.4558 90.9679 88.7337L152.195 104.747C153.429 105.069 153.824 106.623 152.895 107.496L61.4103 193.464C60.0535 194.739 57.969 193.095 58.8932 191.478L96.9461 124.928C97.4757 124.001 96.9813 122.825 95.949 122.555L30.927 105.549C29.6533 105.216 29.287 103.584 30.2962 102.739Z",
    fill: "url(#paint0_linear_1732_19098)",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.6553 8.18652C139.453 8.80484 178.821 48.5552 178.821 97.5L178.813 98.6553C178.195 147.454 138.445 186.821 89.5 186.821L88.3457 186.813C39.9318 186.2 0.799974 147.069 0.186523 98.6553L0.179688 97.5C0.17991 48.1699 40.1699 8.17991 89.5 8.17969L90.6553 8.18652ZM89.5 8.7959C40.5101 8.79612 0.796121 48.5101 0.795898 97.5C0.795898 146.49 40.5099 186.205 89.5 186.205C138.49 186.205 178.205 146.49 178.205 97.5C178.205 48.5099 138.49 8.7959 89.5 8.7959ZM90.3896 28.7949C127.927 29.2706 158.21 59.8472 158.21 97.4971L158.204 98.3857C157.728 135.923 127.151 166.206 89.501 166.206L88.6133 166.2C51.3717 165.729 21.2708 135.627 20.7988 98.3857L20.793 97.4971C20.7931 59.5507 51.5546 28.7892 89.501 28.7891L90.3896 28.7949ZM89.501 29.2627C51.8163 29.2628 21.2667 59.8124 21.2666 97.4971C21.2666 135.182 51.8163 165.731 89.501 165.731C127.186 165.731 157.735 135.182 157.735 97.4971C157.735 59.8124 127.186 29.2627 89.501 29.2627ZM90.1836 44.6484C119.059 45.0139 142.354 68.5353 142.354 97.4971L142.349 98.1797C141.983 127.055 118.463 150.35 89.501 150.35L88.8174 150.345C60.17 149.982 37.015 126.827 36.6523 98.1797L36.6484 97.4971C36.6484 68.3074 60.3113 44.6445 89.501 44.6445L90.1836 44.6484ZM89.501 45.0088C60.5127 45.0088 37.0127 68.5088 37.0127 97.4971C37.0127 126.485 60.5127 149.985 89.501 149.985C118.489 149.985 141.989 126.485 141.989 97.4971C141.989 68.5088 118.489 45.0088 89.501 45.0088ZM90.4102 62.2773C109.45 62.7598 124.735 78.3453 124.735 97.501L124.724 98.4102C124.241 117.449 108.656 132.735 89.501 132.735L88.5908 132.724C69.8538 132.249 54.7521 117.147 54.2773 98.4102L54.2656 97.501C54.2656 78.0412 70.0412 62.2656 89.501 62.2656L90.4102 62.2773ZM89.501 62.5088C70.1754 62.5088 54.5088 78.1754 54.5088 97.501C54.509 116.826 70.1755 132.492 89.501 132.492C108.826 132.492 124.492 116.826 124.492 97.501C124.492 78.1755 108.826 62.509 89.501 62.5088Z",
    fill: "url(#paint1_linear_1732_19098)",
    fillOpacity: 0.22
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1732_19098",
    x: 25.7148,
    y: 20.8906,
    width: 131.691,
    height: 181.027,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1732_19098"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1732_19098",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1732_19098",
    x1: 116.447,
    y1: 9.58504,
    x2: 93.2242,
    y2: 412.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1732_19098",
    x1: 72.5,
    y1: 90.5,
    x2: 77,
    y2: 177.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentureverselightning);
export default __webpack_public_path__ + "static/media/ventureverselightning.2ea50c846e4704cb53adb13a95909e28.svg";
export { ForwardRef as ReactComponent };